import axios from 'axios'
import Swal from 'sweetalert2'

export default async function onSubmitWorking(participantId, companyName, position, lokasi, salary, startYear, endYear, summary, open, setOpen, working, setWorking) {
    let array = [companyName, position, lokasi, salary, startYear, summary]

    for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element == null || element == '') {
            return alert('Lengkapi data mu') 
        }
    }

    Swal.showLoading()
    axios.post(`${process.env.REACT_APP_API}/participant/biodata/working`, {
        participant_id: participantId,
        company_name: companyName,
        position: position,
        location: lokasi,
        salary: salary,
        year_start: startYear,
        year_end: endYear,
        summary: summary
    })
        .then(function (response) {
            Swal.close()
            setOpen(false)
            let obj = {
                company_name: companyName,
                position: position,
                location: lokasi,
                salary: salary,
                year_start: startYear,
                year_end: endYear,
                summary: summary
            }
            setWorking([...working, obj])
            // history.push({
            //     pathname: '/biodata/working',
            //     state: { participantId: biodata.participantId, name: biodata.fullname }
            // })
        })
        .catch(function (error) {
            Swal.close()
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error
            })
        })
}